"use client";
import { AppMenu } from "@/shared";
import { useEffect, useState } from "react";
import { match } from "path-to-regexp";
import { usePathname, useRouter } from "next/navigation";
import { PageMenuTitle } from "@/shared/app/ui/text/PageMenuTitle";
function NavItem({ item }: { item: any }) {
  const router = useRouter();
  const currentPath = usePathname() || "";

  const isActive =
    item.paths &&
    item.paths.some((path: any) => {
      const urlMatch = match(path);
      return urlMatch(currentPath);
    });

  const onClick = () => {
    if (item.paths && item.paths[0]) {
      router.push(item.paths[0]);
    }
  };
  return (
    <li
      className={`md:text-2xl md:leading-8  sm:text-lg sm:leading-7 text-base leading-6 tracking-tight  cursor-pointer py-4 px-5 md:px-6 md:py-6 transition-colors duration-200 ${
        isActive
          ? "text-black-almostBlack border-b-2 md:border-b-4 border-black-almostBlack"
          : "text-lightGray-30 hover:lightGray-30"
      }`}
      onClick={onClick}
      style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
    >
      {item.title}
    </li>
  );
}

export function AppPageTitle() {
  const currentPath = usePathname() || "";

  const [isVisible, setIsVisible] = useState(false);
  // 2. 컴포넌트가 마운트된 후 isVisible 상태를 true로 변경하여 애니메이션을 트리거
  useEffect(() => {
    // 50ms 딜레이는 CSS 트랜지션을 확실하게 활성화하는 데 도움을 줍니다.
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 50);

    return () => clearTimeout(timer); // 클린업
  }, []);
  return (
    <>
      {AppMenu.map((item, i) => {
        const isActive =
          item.paths &&
          item.paths.some((path: any) => {
            const urlMatch = match(path);
            return urlMatch(currentPath);
          });

        if (isActive) {
          const animationClasses = `
            transition-all duration-1000 ease-out 
            ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-4"
            }
          `;

          return (
            // 애니메이션을 적용할 최상위 컨테이너
            <div key={i} className={animationClasses}>
              {/* 페이지 타이틀 섹션 */}
              <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-0 py-8 md:py-12 lg:py-24">
                <PageMenuTitle
                  menu={item.title}
                  description={item.description}
                />
              </div>

              <div className="w-full">
                {/* 탭 버튼 */}
                <ul className="flex w-full xl:max-w-[1280px] mx-auto ">
                  {item.children?.map((tab, t) => (
                    <NavItem key={t} item={tab} />
                  ))}
                </ul>
              </div>
            </div>
          );
        }
      })}
    </>
  );
}
